import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { priceGetFormattedPrice } from '../../../../../price'
import {
  ATTRIBUTE_NAME_COLOR_NUMBER,
  ATTRIBUTE_NAME_PACKAGE_SIZE,
} from '../../../product-page-context/ATTRIBUTE_NAME'
import { useProductPageContext } from '../../../productPageContext'
import { useProductPrices } from '../../hooks/useProductPrices'

const getFormattedPackageSize = (
  label: string,
  quantity: string | undefined,
  unit: string | undefined,
): string => {
  const packageSize = [quantity, unit].filter(Boolean).join(' ')

  return packageSize ? `${label}: ${packageSize}` : ''
}

export const ProductBuyBoxStickyPriceAndPackage: FC = () => {
  const { currentPrescriptionType, offerId, product } = useProductPageContext()
  const { displayPrice } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })
  const intl = useIntl()

  const attributes: string[] = []
  if (product.variant_attributes) {
    for (const attribute of product.variant_attributes) {
      if (attribute.variant_attribute !== ATTRIBUTE_NAME_PACKAGE_SIZE) {
        const trimmedLabel = attribute.label?.trim() ?? ''
        const label =
          attribute.variant_attribute === ATTRIBUTE_NAME_COLOR_NUMBER
            ? intl.formatMessage({ id: 'variantAttributes.label.color_number' })
            : trimmedLabel
        attributes.push(`${label}: ${attribute.value ?? ''}`)
      }
    }
  }

  attributes.push(
    getFormattedPackageSize(
      intl.formatMessage({
        id: 'variantAttributes.label.package_size',
      }),
      product.package_size?.quantity,
      product.package_size?.unit,
    ),
    product.pharma_form?.label ?? '',
  )

  const productAttributes = attributes.filter(Boolean).join(' | ')

  return (
    <>
      <p className="line-clamp-2 grow text-xs font-medium">
        {productAttributes}
      </p>
      <div className="flex flex-col items-start whitespace-nowrap">
        <span className="text-xs text-dark-primary-medium">
          <FormattedMessage id="general.label.yourPrice" />
        </span>
        <span className="font-bold text-dark-accent">
          {priceGetFormattedPrice(displayPrice?.price ?? 0, intl)}
        </span>
      </div>
    </>
  )
}
